import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import type { WebhookLog, PaginatedResponse } from '@/types/api';

export const webhookLogKeys = {
  all: ['webhook-logs'] as const,
  list: (params?: WebhookLogsParams) => [...webhookLogKeys.all, 'list', params] as const,
  byAccount: (accountId: string, params?: WebhookLogsParams) =>
    [...webhookLogKeys.all, 'account', accountId, params] as const,
};

interface WebhookLogsParams {
  partnerAccountId?: string;
  page?: number;
  limit?: number;
}

export function useWebhookLogs(partnerAccountId?: string, params?: Omit<WebhookLogsParams, 'partnerAccountId'>) {
  const queryParams = new URLSearchParams();
  if (partnerAccountId) queryParams.set('partnerAccountId', partnerAccountId);
  if (params?.page) queryParams.set('page', params.page.toString());
  if (params?.limit) queryParams.set('limit', params.limit.toString());

  const queryString = queryParams.toString();
  const url = `/api/v1/webhooks/logs${queryString ? `?${queryString}` : ''}`;

  return useQuery({
    queryKey: partnerAccountId
      ? webhookLogKeys.byAccount(partnerAccountId, params)
      : webhookLogKeys.list(params),
    queryFn: () => api.get<PaginatedResponse<WebhookLog>>(url),
  });
}
